import React from 'react';
import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface EmptyStateProps {
  icon: LucideIcon;
  headline: string;
  body: string;
  ctaLabel?: string;
  onCta?: () => void;
  className?: string;
  variant?: 'empty' | 'error';
}

export function EmptyState({
  icon: Icon,
  headline,
  body,
  ctaLabel,
  onCta,
  className,
  variant = 'empty',
}: EmptyStateProps) {
  const isError = variant === 'error';
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center py-10',
        isError && 'border border-fail-soft rounded-xl bg-fail-soft/30',
        className
      )}
    >
      <div
        className={cn(
          'w-12 h-12 rounded-full flex items-center justify-center mb-3',
          isError ? 'bg-fail-soft' : 'bg-sunken'
        )}
      >
        <Icon className={cn('h-6 w-6', isError ? 'text-fail' : 'text-ink-muted')} />
      </div>
      <p className="text-base font-medium text-ink">{headline}</p>
      <p className={cn('text-sm mt-1', isError ? 'text-fail' : 'text-ink-muted')}>{body}</p>
      {ctaLabel !== undefined && onCta !== undefined && (
        <button
          type="button"
          onClick={onCta}
          className={cn(
            'mt-4 px-4 py-2 rounded-lg text-sm font-medium transition-colors',
            isError
              ? 'bg-fail text-white hover:bg-fail'
              : 'bg-brand text-on-brand hover:bg-brand-hover'
          )}
        >
          {ctaLabel}
        </button>
      )}
    </div>
  );
}
